import { Button } from '@thanx/uikit/button'
import { Text } from '@thanx/uikit/text'
import { useStyletron } from '@thanx/uikit/theme'
import CountBadge from 'components/CountBadge'
import StatusBadge from 'components/StatusBadge'
import React from 'react'
import { LinkContainer } from 'react-router-bootstrap'
import type { NeedsAttentionRowData } from './useNeedsAttention'

// Row visual spacing.
const ROW_GAP_PX = '12px'
const ROW_PADDING = '16px 20px'

type Props = Omit<NeedsAttentionRowData, 'id'>

const NeedsAttentionRow = ({
  count,
  srLabel,
  title,
  titleSuffix,
  pilotLabel,
  buttonLabel,
  to,
}: Props) => {
  const [css] = useStyletron()
  return (
    <div
      className={css({
        display: 'flex',
        alignItems: 'center',
        gap: ROW_GAP_PX,
        padding: ROW_PADDING,
      })}
    >
      {/* No className: the row owns spacing via flex/gap (badge is margin-free). */}
      <CountBadge count={count} srLabel={srLabel} size="lg" />
      <div className={css({ flex: 1 })}>
        <span className={css({ display: 'inline-flex', alignItems: 'center' })}>
          <Text.BodyText2 tag="span" bold color="grey90">
            {title}
          </Text.BodyText2>
          {/* Flex items drop the whitespace between them, so the suffix carries
              its own margin. ml-xxs (4px) ~ one word space; ml-xs read as two. */}
          {pilotLabel && <StatusBadge type="coming_soon" text={pilotLabel} />}
          {titleSuffix && (
            <Text.BodyText2 tag="span" bold color="grey90" className="ml-xxs">
              {titleSuffix}
            </Text.BodyText2>
          )}
        </span>
      </div>
      {/* LinkContainer (C2): navigates the single uikit <button> via injected
          onClick — no nested <a><button>. Internal React Router nav, no reload. */}
      <LinkContainer to={to}>
        <Button kind="secondary">{buttonLabel}</Button>
      </LinkContainer>
    </div>
  )
}

export default NeedsAttentionRow
